import { useHistory } from 'react-router'
import { nifRegex } from 'login-and-signup/validation'
import TextBlock from 'login-and-signup/components/TextBlock'
import { pendingSelector } from 'api/selectors'
import { FormattedMessage } from 'react-intl'

import {
    acceptTermsLabelSelector,
    subscribeOffersLabelSelector,
    subscribeNewsLabelSelector,
    signupTextblockUpSelector,
    signupTextblockDownSelector,
} from 'wordpress/selectors'
import featureToggles from 'shared/featureToggles'
import { CUSTOMER_TYPE_CO_BUSINESS, CUSTOMER_TYPE_BUSINESS } from 'shared/constants'
import DocumentDataFields from 'shared/components/DocumentDataFields'
import Button from 'shared/components/Button'
import FormsyInput from 'shared/components/Textfield/withFormsy'
import CheckBox from 'shared/components/Checkbox/withFormsy'
import PasswordField from 'shared/components/PasswordField/PasswordField'

const DefaultFlowForm = ({
    active,
    canSubmit,
    acceptTerms,
    acceptTermsHandler,
    customerType,
    acceptTermsLabel,
    textblockUp,
    subscribeNewsLabel,
    subscribeOffersLabel,
    textblockDown,
    pending,
    translate: t,
    signUpFormError,
}) => {
    const history = useHistory()

    const minPasswordSymbolsNumber = window.PASSWORD_MIN_SYMBOLS_NUMBER

    return (
        <>
            <FormsyInput
                autoFocus={active}
                id="firstName"
                name="firstName"
                type="text"
                validations={{
                    matchRegexp: /.+/,
                }}
                validationError={t('auth.firstname.error')}
                label={t('auth.firstname.label')}
                autoComplete="given-name"
                required
            />
            <FormsyInput
                id="lastName"
                name="lastName"
                type="text"
                validations={{
                    matchRegexp: /.+/,
                }}
                validationError={t('auth.lastname.error')}
                label={t('auth.lastname.label')}
                autoComplete="family-name"
                required
            />
            <div className="header-form-strip form-group">
                <CheckBox required name="acceptTerms" label={acceptTermsLabel} onChange={acceptTermsHandler} />
            </div>
            {acceptTerms && (
                <div>
                    <span className="d-block font-weight-bold pb-3">
                        <T>auth.fields.info</T>
                    </span>
                    {featureToggles.nifRequired && (
                        <FormsyInput
                            id="nif"
                            name="nif"
                            uppercase
                            type="text"
                            validations={{
                                matchRegexp: nifRegex,
                            }}
                            validationError={t('auth.nif.error')}
                            label={t('auth.nif.label')}
                            required
                        />
                    )}
                    <FormsyInput
                        id="email"
                        name="email"
                        validations="isEmail"
                        validationError={t('auth.email.error')}
                        label={t('auth.email.label')}
                        autoComplete="email"
                        required
                    />
                    {featureToggles.confirmSignUpEmail && (
                        <FormsyInput
                            id="confirmEmail"
                            name="confirmEmail"
                            validations="isEmail,equalsField:email"
                            validationError={t('auth.email.confirm.error')}
                            label={t('auth.email.confirm.label')}
                            required
                            autoComplete="email"
                            onPaste={e => e.preventDefault()}
                        />
                    )}
                    <PasswordField
                        autoComplete="new-password"
                        validations={{
                            matchRegexp: new RegExp(
                                `^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[^\\da-zA-Z]).{${minPasswordSymbolsNumber},25}$`
                            ),
                        }}
                        validationErrors={{
                            matchRegexp: (
                                <FormattedMessage id="auth.password.hint" values={{ minPasswordSymbolsNumber }} />
                            ),
                        }}
                        touched
                    />
                    {featureToggles.additionalSignupData &&
                        [CUSTOMER_TYPE_CO_BUSINESS, CUSTOMER_TYPE_BUSINESS].includes(customerType) && (
                            <>
                                <FormsyInput
                                    id="businessName"
                                    name="businessName"
                                    type="text"
                                    validations={{
                                        matchRegexp: /.+/,
                                    }}
                                    validationError={t('auth.businessname.error')}
                                    label={t('auth.businessname.label')}
                                    required
                                />
                            </>
                        )}
                    {featureToggles.additionalSignupData && (
                        <DocumentDataFields
                            documentType={customerType}
                            hideType={
                                !featureToggles.isColumbia ||
                                [CUSTOMER_TYPE_CO_BUSINESS, CUSTOMER_TYPE_BUSINESS].includes(customerType)
                            }
                        />
                    )}
                    <FormsyInput
                        name="phone"
                        type="text"
                        label={t('dashboard.account.phone')}
                        autoComplete="tel"
                        validations={
                            featureToggles.caPurchaseFlow
                                ? { isNumeric: true, minLength: 10, maxLength: 10 }
                                : { isNumeric: true }
                        }
                        validationError={t('dashboard.account.phone.invalid')}
                        required
                    />
                    {textblockUp && <TextBlock content={textblockUp} />}
                    {subscribeOffersLabel && (
                        <div className="header-form-strip form-group">
                            <CheckBox name="offers" label={subscribeOffersLabel} />
                        </div>
                    )}
                    {subscribeNewsLabel && (
                        <div className="header-form-strip form-group">
                            <CheckBox name="news" label={subscribeNewsLabel} />
                        </div>
                    )}
                    {textblockDown && <TextBlock content={textblockDown} />}
                </div>
            )}
            {signUpFormError}
            <Button
                className="mt-2"
                type="submit"
                isLoading={pending.createAccount === true}
                onClick={() => history.push({ hash: false })}
                disabled={!canSubmit || !acceptTerms}>
                <T>auth.sign.up.btn.label</T>
            </Button>
        </>
    )
}
export default compose(
    withTranslate,
    connect(
        createStructuredSelector({
            pending: pendingSelector,
            acceptTermsLabel: acceptTermsLabelSelector,
            subscribeOffersLabel: subscribeOffersLabelSelector,
            subscribeNewsLabel: subscribeNewsLabelSelector,
            textblockUp: signupTextblockUpSelector,
            textblockDown: signupTextblockDownSelector,
        })
    )
)(DefaultFlowForm)
